/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';

module.exports = Odigeo.Model.extend({
    defaults: {
        resultsPerPage: null,
        totalPages: null,
        pageToLoad: 1,
        paginationMaxPageSet: null,
        numberOfResults: null,
        trackingLabel: null,
    },

    updatePage: function(resetPagination) {
        if (resetPagination) {
            this.set('pageToLoad', this.defaults.pageToLoad);
        }
    },

    updateModel: function(data) {
        this.set('numberOfResults', +data.numResults);
        this.set('numberOfResultsAfterFiltering', +data.numFilteredResults);
        this.set('totalPages', Math.ceil(this.get('numberOfResultsAfterFiltering') / this.get('resultsPerPage')));
        this.set('trackingLabel', 'page_selected_' + this.get('pageToLoad'));

        if (data.numResults > 0) {
            this.trigger('newResults');
        }
    },

    clearModel: function() {
        this.updatePage(true);
        this.updateModel({
            numFilteredResults: 0,
            numResults: 0,
        });
    },

    getFromToObject: function() {
        return {
            from: (this.get('pageToLoad') - 1) * this.get('resultsPerPage'),
            to: this.get('pageToLoad') * this.get('resultsPerPage'),
        };
    },

    hasMoreThanOnePage: function() {
        return (this.get('numberOfResultsAfterFiltering') > this.get('resultsPerPage'));
    },
});
